import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
} from 'react';
import useWizardStore from '@zs/useWizardStore';
import * as common from '@/common';
import * as elements from '@svg/elements';
import {
  octSettings,
} from '@/imageFiles';
import { useImageCache } from '@/useImageCache';


export function useEnfaceViewer(
  eye: 'OD' | 'OS',
  fixed: boolean,
) {
  const registration = useWizardStore(state => state.registrations[eye]);
  const fovealPit = useWizardStore(state => state.fovealPit[eye]);
  const cacheHook = useImageCache(eye);

  const regMemo = useMemo(() => {
    if (fixed || !registration)
      return '';
    return elements.transformAttr(registration.FAF);
  }, [fixed, registration]);

  const foveaMemo = useMemo(() => {
    if (!cacheHook)
      return undefined;
    return elements.getFoveaDeg(fovealPit, cacheHook.BSCAN.crop.width);
  }, [fovealPit, cacheHook]);

  const scaleMemo = useMemo(() => {
    if (!cacheHook)
      return undefined;
    const scaleRED = octSettings.enfaceAngle / cacheHook.RED.crop.width;
    const scaleFAF = octSettings.enfaceAngle / cacheHook.FAF.crop.width;
    if (fixed || regMemo)
      return scaleRED;
    return scaleFAF;
  }, [fixed, cacheHook, regMemo]);

  return {
    regAttr: regMemo,
    fovDeg: foveaMemo,
    scale: scaleMemo,
  };
}
